// extracted by mini-css-extract-plugin
export default {"accordion":"accordion_accordion__pwJE6","label":"accordion_label__1H1ef","arrow":"accordion_arrow__DZk+5","reversed":"accordion_reversed__yiFZQ"};